import { ReactNode, useState } from 'react';
import styles from './HighlightInfo.module.scss';

type HighlightInfoProps = {
  title: ReactNode;
  description?: string;
};

export const HighlightInfo = ({ title, description }: HighlightInfoProps) => {
  // FIXME: make png visible both on Sites and White Label Host
  const [imageVisible, setImageVisible] = useState(true);

  return (
    <div className={styles.card}>
      <div className={styles.container}>
        {imageVisible && (
          <img
            className={styles.image}
            src="/images/highlight-info/savings-graph-person.png"
            srcSet="/images/highlight-info/savings-graph-person.png 1x, /images/highlight-info/savings-graph-person@2x.png 2x, /images/highlight-info/savings-graph-person@3x.png 3x"
            loading="lazy"
            alt="Chart and Person saving money"
            onErrorCapture={() => setImageVisible(false)}
          />
        )}

        <div className={styles.title}>{title}</div>

        {description && (
          <div data-testid="description" className={styles.description}>
            {description}
          </div>
        )}
      </div>
    </div>
  );
};
